var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-autocomplete',_vm._b({staticStyle:{"width":"100%"},attrs:{"fetch-suggestions":_vm.querySearch,"placeholder":"请输入内容","trigger-on-focus":false},model:{value:(_vm.localValue),callback:function ($$v) {_vm.localValue=$$v},expression:"localValue"}},'el-autocomplete',_vm.$attrs,false))
}
var staticRenderFns = []

export { render, staticRenderFns }